import { motion } from 'framer-motion';
import { Target, Heart } from 'lucide-react';

const About = () => {
  return (
    <section id="about" className="py-24 bg-white dark:bg-dark">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6 }}
          >
            <span className="text-highlight font-medium text-sm uppercase tracking-wider">About Us</span>
            <h2 className="text-4xl md:text-5xl font-display font-bold text-primary dark:text-white mt-3 mb-6">
              Building Digital Presence With Purpose
            </h2>
            <p className="text-gray-600 dark:text-gray-300 text-lg leading-relaxed mb-6">
              Xavier Agency was founded on a simple belief: every business deserves a website that
              reflects its true value. We don't do cookie-cutter templates or rushed jobs. Every site
              we build is crafted with intention — designed to convert visitors into customers.
            </p>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed mb-8">
              Whether you're a startup finding your feet or an established business ready for a refresh,
              we bring the same level of care and strategic thinking to every project. Based in London,
              working with clients worldwide.
            </p>
            <div className="grid grid-cols-2 gap-6">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.1 }}
                className="p-4 rounded-xl bg-gray-50 dark:bg-secondary/50"
              >
                <Target className="text-highlight mb-2" size={24} />
                <p className="text-2xl font-bold text-primary dark:text-white">Custom</p>
                <p className="text-sm text-gray-500 dark:text-gray-400">Bespoke Solutions</p>
              </motion.div>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.2 }}
                className="p-4 rounded-xl bg-gray-50 dark:bg-secondary/50"
              >
                <Heart className="text-highlight mb-2" size={24} />
                <p className="text-2xl font-bold text-primary dark:text-white">Dedicated</p>
                <p className="text-sm text-gray-500 dark:text-gray-400">Client Focused</p>
              </motion.div>
            </div>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6 }}
            className="relative"
          >
            <div className="aspect-[4/5] rounded-2xl overflow-hidden bg-gradient-to-br from-primary to-accent">
              <img
                src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800&h=1000&fit=crop"
                alt="Xavier Agency team collaborating"
                className="w-full h-full object-cover opacity-80"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary/80 to-transparent" />
              <div className="absolute bottom-8 left-8 right-8">
                <blockquote className="text-white text-lg font-medium italic">
                  "We don't just build websites. We build the digital foundation your business deserves."
                </blockquote>
                <p className="text-white/70 text-sm mt-3">— Xavier Agency Team</p>
              </div>
            </div>
            <div className="absolute -top-6 -right-6 w-24 h-24 bg-highlight/20 rounded-full blur-2xl" />
            <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-accent/20 rounded-full blur-2xl" />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
